export { makeRumPublicApi } from './boot/rumPublicApi';
export { ActionType, RumEventType, FrustrationType } from './rawRumEvent.types';
export { startRum } from './boot/startRum';
export { LifeCycle } from './domain/lifeCycle';
export { startViewHistory } from './domain/contexts/viewHistory';
export { getMutationObserverConstructor } from './browser/domMutationObservable';
export { initViewportObservable, getViewportDimension } from './browser/viewportObservable';
export { getScrollX, getScrollY } from './browser/scroll';
export { DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE } from './domain/action/actionNameConstants';
export { STABLE_ATTRIBUTES } from './domain/getSelectorFromElement';
export * from './browser/htmlDomUtils';
export { getSessionReplayUrl } from './domain/getSessionReplayUrl';
export { sanitizeIfLongDataUrl } from './domain/resource/resourceUtils';
export * from './domain/privacy';
export * from './domain/privacyConstants';
export { supportPerformanceTimingEvent } from './browser/performanceObservable';
export { RumPerformanceEntryType } from './browser/performanceObservable';
export { createHooks } from './domain/hooks';
export { isSampled } from './domain/sampler/sampler';
//# sourceMappingURL=index.js.map